<template>
  <div class="w-full">
    <!-- Slider -->
    <div class="relative mb-6">
      <input
        type="range"
        :min="0"
        :max="plans.length - 1"
        :value="selectedIndex"
        @input="updateSelection"
        class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
        :style="{ background: sliderBackground }"
      />
      

    </div>
    
    <!-- Range labels -->
    <div class="flex justify-between text-sm text-gray-500 -mt-2">
      <span>{{ formatNumber(plans[0]?.limit || 0) }} credits</span>
      <span>{{ formatNumber(plans[plans.length - 1]?.limit || 0) }} credits</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanSlider',
  props: {
    plans: {
      type: Array,
      required: true,
      default: () => []
    },
    modelValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue', 'planSelected'],
  computed: {
    selectedIndex() {
      return this.modelValue;
    },
    sliderBackground() {
      if (this.plans.length <= 1) return '#e5e7eb';
      
      const percentage = (this.selectedIndex / (this.plans.length - 1)) * 100;
      return `linear-gradient(to right, #ff8e03 0%, #ff8e03 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`;
    }
  },
  methods: {
    updateSelection(event) {
      const index = parseInt(event.target.value);
      this.$emit('update:modelValue', index);
      this.$emit('planSelected', this.plans[index]);
    },
    formatNumber(num) {
      if (num >= 1000000) {
        return (num / 1000000).toFixed(num % 1000000 === 0 ? 0 : 1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(num % 1000 === 0 ? 0 : 1) + 'K';
      }
      return num?.toLocaleString() || '0';
    }
  }
};
</script>

<!-- Slider track styling -->
<style scoped>
.slider::-webkit-slider-thumb {
    appearance: none;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #ff8e03;
    cursor: pointer;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.slider::-moz-range-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #ff8e03;
    cursor: pointer;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.slider:focus {
    outline: none;
}

.slider:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 3px rgba(255, 142, 3, 0.3);
}
</style>